import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { productionOrderDetailsPartConfig } from './config';

const ProductionOrderDetailsPartStack = createStackNavigator();

const ProductionOrderDetailsPartNavigator = () => {
  return (
    <ProductionOrderDetailsPartStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {productionOrderDetailsPartConfig.map(({ Component, name }) => (
        <ProductionOrderDetailsPartStack.Screen key={name} name={name} component={Component} />
      ))}
    </ProductionOrderDetailsPartStack.Navigator>
  );
};

export { ProductionOrderDetailsPartNavigator };
